import { forwardRef } from 'react'
import PropTypes from 'prop-types'

const Group = forwardRef(({ left = 0, top = 0, transform, ...rest }, ref) => {
  return (
    <g
      ref={ref}
      transform={transform || `translate(${left}, ${top})`}
      {...rest}
    />
  )
})

Group.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  transform: PropTypes.string
}

export default Group
